import React, { useEffect, useMemo, useState, useContext } from "react";
import axios from "axios";
import { Button, Modal, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../utils/config";
import Papa from "papaparse";
import MdDeleteForever from "../../Img/delete.png";
// import { FaGlasses, FaUserEdit } from "react-icons/fa";
import FaUserEdit from "../../Img/edit user.png";
import { MDBDataTable } from "mdbreact";
import "mdbreact/dist/css/mdb.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import UploadImage from "../../Img/upload.png";
import CreateUser from "../../Img/add user.png";
import DownloadSampleCsv from "../../Img/download.png";
import UpdateImage from "../../Img/update.png";
import DownloadCsv from "../../Img/bulk user download.png";
import NewTopNavBar from "../NewTopNavBar";
import Select from "react-select";
import { saveAs } from "file-saver";
// import 'bootstrap-css-only/css/bootstrap.min.css';

import GlobalContext from "../../context/GlobalContext";

function CreateNewUserForm() {
  const [selectedFile, setSelectedFile] = useState(null);
  //
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 5;
  const [users, setUsers] = useState([]);
  const [tenantUsers, setTenantUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [show, setShow] = useState(false);
  const [createUsersShow, setCreateUsersShow] = useState(false);
  const [editUsers, setEditUsers] = useState([]);
  const [editId, setEditId] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [deleteUsers, setDeleteUsers] = useState(false);
  const [totalNoOfUsers, setTotalNoOfUsers] = useState("");
  const [collaps, setCollaps] = useState(true);
  const [reload, setReload] = useState(false);
  const [page, setPage] = useState(2);
  const [errors, setErrors] = useState({});
  const [allArticle, setAllArticle] = useState([]);
  const [userDeletReload, setUserDeleteReload] = useState(false);
  let loadTagJson = false;
  const [formData, setFormData] = useState({
    username: "",
    // first_name: '',
    // last_name: '',
    // password: '',
    email: "",
    selectedRole: "",
    status: "",
    tags: [],
  });
  const [createUsersFormData, setCreateUsersFormData] = useState({
    username: "",
    email: "",
    selectedRole: "",
    // status: 'active',
    password: "",
  });

  // create random password
  const [password, setPassword] = useState("");

  const [tagsList, setTagsList] = useState([]);
  const [selectedTagOption, setSelectedTagOption] = useState([]);
  const [defaultTagList, setDefaultTagList] = useState([]);
  const [tagDropDownKey, setTagDropDownKey] = useState(0);
  const [roles, setRoles] = useState([]);
  const { notificationCount, setNotificationCount } = useContext(GlobalContext);

  // create randompassword

  const handleClose = () => {
    setShow(false);
    setCreateUsersShow(false);
    setCreateUsersFormData({
      username: "",
      email: "",
      password: "",
      selectedRole: "",
    });
    setErrors("");
    // setSelectedTagOption([])
  };
  const handleShow = (id) => {
    setEditId(id);
    // alert(id)
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/user-details/${id}`, {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // setUsers(response.data);

        setEditUsers(response.data);
        // setLoading(false)
        // setApiRespose(response.data.slice(0, 8))
        console.log("line104=", response.data);
        setFormData({
          ...formData,
          username: response.data.user_login,
          selectedRole: response.data.user_roles,
          email: response.data.user_email,
          status: response.data.user_status,
          tags: response.data.user_tags,
        });
        if (
          response.data.hasOwnProperty("user_tags") &&
          response.data["user_tags"] !== ""
        ) {
          console.log(response.data);
          let tagIds = response.data["user_tags"];
          let defValues = tagsList.filter((item) => tagIds.includes(item.id));
          console.log("defval=", defValues);
          setDefaultTagList(defValues);
          setSelectedTagOption(defValues);
          setTagDropDownKey(tagDropDownKey + 1);
          setFormData({
            ...formData,
            username: response.data.user_login,
            selectedRole: response.data.user_roles,
            email: response.data.user_email,
            status: response.data.user_status,
            tags: response.data["user_tags"],
          });
          setShow(true);
        } else {
          setFormData({
            ...formData,
            username: response.data.user_login,
            selectedRole: response.data.user_roles,
            email: response.data.user_email,
            status: response.data.user_status,
            tags: [],
          });
          setDefaultTagList([]);
          setSelectedTagOption([]);
          setTagDropDownKey(tagDropDownKey + 1);
          setShow(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
    // setShow(true);
  };

  const createusersHandleChange = () => {
    setCreateUsersShow(true);
    formData.username = "";
    formData.email = "";
    setDefaultTagList([]);
    setSelectedTagOption([]);
  };

  //
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  //
  let bearerToken = localStorage.getItem("jwt_token");

  console.log("lin");
  //
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
      // 'X-Wp-Nonce': '6de9be6ced',
      // 'Content-Type': 'application/json',
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      // 'Content-Type': 'multipart/form-data',
      // 'X-Wp-Nonce': '6de9be6ced',
      "Content-Type": "application/json",
    },
  };
  //

  const handleUpload = () => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("author", localStorage.getItem("roles"));

      axios
        .post(
          `${API_BASE_URL}/wp-json/custom-csv-import/v1/import`,
          formData,
          config
        )
        .then((response) => {
          // Handle the response here
          console.log("response=", response);
          document.getElementById("csvFile").value = "";
          setSelectedFile(null);
          if (response.status == 200) {
            toast.success("User updated successfully");
            setReload(reload ? false : true);
            setSuccess(true);
            setNotificationCount(notificationCount + 1);

            //store notification count start

            let notification_count = {
              // "user_id": "",
              count_value: "",
              reflect_count: "all_admin",
            };
            if (notification_count.count_value == "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count,
                  config2
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            // store notification count end

            //recomandation data
            let notification_api_data = {
              author: localStorage.getItem("display_name"),
              // name: createUsersFormData.username,
              event_type: "User Created via CSV",
              value: response.data.count - 1,
              email: localStorage.getItem("userEmail"),
              // user_role: createUsersFormData.selectedRole,
              author_ids: localStorage.getItem("current_user_Id"),
            };

            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                notification_api_data,
                config2
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });

            // recomandation data
          } else {
            setReload(reload ? false : true);
            setSuccess(true);
            let count = response.data.count;
            const showToastMessages = (messages) => {
              messages.unshift(
                `${messages.length} users failed to upload" Reason:`
              );
              messages.unshift(
                `${count - messages.length} users successfully uploaded `
              );
              // messages.push("Others users are uploded succesfully")

              console.log(messages);
              const toastContent = messages.join("<br/>");
              toast.warning(
                <div dangerouslySetInnerHTML={{ __html: toastContent }} />,
                {
                  // position: toast.POSITION.TOP_LEFT,
                  // Other options as needed
                }
              );
            };

            showToastMessages(response.data.warnings);
            setSuccess(true);
            console.log(
              `count= ${count} type= ${typeof count}  warning =${response.data.warnings.unshift(response.data.warnings.length) -
              count
              } type=${response.data.warnings.length}`
            );
            //recomandation data
            setNotificationCount(notificationCount + 1);

            //store notification count start

            let notification_count = {
              // "user_id": "",
              count_value: "",
              reflect_count: "all_admin",
            };
            if (notification_count.count_value == "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count,
                  config2
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            // store notification count end

            let notification_api_data = {
              author: localStorage.getItem("display_name"),
              // name: createUsersFormData.username,
              event_type: "User Created via CSV",
              value: response.data.succesCount,
              email: localStorage.getItem("userEmail"),
              // user_role: createUsersFormData.selectedRole,
              author_ids: localStorage.getItem("current_user_Id"),
            };

            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                notification_api_data,
                config2
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });

            // recomandation data
            // setTimeout(() => {
            //   window.location.reload();
            // }, 3000);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(error?.response?.data.message);
          // Handle any errors here
        })
        .finally((err) => {
          // toast.error("File is not uploaded")
        });
    } else {
      toast.error("Please choose file to upload");
    }
  };
  //

  const deleteBtn = (deleteId) => {
    // setCount(count + 1)
    const username = "ramnaresh";
    const password = "o(oLKgVkO28bHhKZ%L82Jv1C";
    const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/delete-user/${deleteId}`;

    const config = {
      headers: {
        Authorization: `Bearer ${bearerToken}`,
        "Content-Type": "application/json",
      },
    };

    axios
      .delete(apiEndpoint, config)
      .then((response) => {
        setDeleteUsers(true);
        toast.success("User Deleted Successfully");
      })
      .catch((error) => {
        console.error("Error deleting post:", error);
      });
  };
  //

  //

  // const roles = ['subscriber', 'editor', 'author', 'contributor', 'administrator'];

  const checkPlatform = () => {
    let role = [];
    axios
      .get(`${API_BASE_URL}/wp-json/custom/v1/toggle-option`, config)
      .then((res) => {
        console.log("line399=", res.data.value);
        if (localStorage.getItem("roles") == "editor") {
          role =
            res.data.value != "1"
              ? [
                { name: "subscriber", value: "Reader" },
                { name: "author", value: "Author" },
                { name: "editor", value: "Tenant Admin" },

              ]
              : [
                // { name: "subscriber", value: "Reader" },
                { name: "author", value: "Author" },
                // { name: 'administrator', value: 'Administrator' },
                // { name: 'editor', value: 'Tenant Admin' }
              ];
        } else {
          // alert("dfgdg");
          role =
            res.data.value != "1"
              ? [
                { name: "subscriber", value: "Reader" },
                { name: "author", value: "Author" },
                { name: "administrator", value: "Administrator" },
                { name: "editor", value: "Tenant Admin" },
              ]
              : [
                { name: "subscriber", value: "Reader" },
                { name: "author", value: "Author" },
                { name: "administrator", value: "Administrator" },
                { name: "editor", value: "Tenant Admin" },
              ];
        }
        setRoles(role);
        // console.log("rolles434=", roles);
      });
  };
  // console.log("rolles434=", roles);
  // localStorage.getItem("roles") == "editor"
  //   ? (roles = [
  //       // { name: "subscriber", value: "Reader" },

  //       { name: "author", value: "Author" },

  //       // { name: 'administrator', value: 'Administrator' },
  //       // { name: 'editor', value: 'Tenant Admin' }
  //     ])
  //   : (roles = [
  //       // { name: "subscriber", value: "Reader" },

  //       { name: "author", value: "Author" },

  //       { name: "administrator", value: "Administrator" },
  //       { name: "editor", value: "Tenant Admin" },
  //     ]);
  useEffect(() => {
    checkPlatform();
  }, []);
  const handleChangeCreateUsers = (e) => {
    e.preventDefault();
    const { name, value } = e.target;

    // console.log(`231 name= ${name}. value= ${value}`)

    setCreateUsersFormData({
      ...createUsersFormData,
      [name]: value,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };
  // let bearerToken = localStorage.getItem('jwt_token');
  const handleRoleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmitCreateUsers = (e) => {
    e.preventDefault();
    // alert(editId)

    const newErrors = {};

    if (!createUsersFormData.username) {
      newErrors.username = "Username is required";
    }

    // if (!createUsersFormData.password) {
    //   newErrors.password = 'Password is required';
    // }
    if (!createUsersFormData.email) {
      newErrors.email = "Email is required";
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(createUsersFormData.email) == false) {
        newErrors.email = "Invalid Email";
      } else {
        // newErrors.email = ""
      }
    }
    if (!createUsersFormData.selectedRole) {
      newErrors.selectedRole = "Role is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      let tagIds = selectedTagOption.map((o) => o.id);
      const userData = {
        username: createUsersFormData.username,
        password: createUsersFormData.password,
        email: createUsersFormData.email,
        selectedRole: createUsersFormData.selectedRole,
        tags: tagIds !== undefined ? tagIds : [],
      };

      userData.password = password;

      axios
        .post(
          `${API_BASE_URL}/wp-json/custom/v1/create-user/`,
          userData,
          config2
        )
        .then((response) => {
          toast.success("User Created Successfully");
          setCreateUsersShow(false);

          //store notification count start

          let notification_count = {
            // "user_id": "",
            count_value: "",
            reflect_count: "all_admin",
          };
          if (notification_count.count_value == "") {
            // post notification on usermeta start
            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                notification_count,
                config2
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });
          }

          // store notification count end

          setNotificationCount(notificationCount + 1);
          //recomandation data
          let notification_api_data = {
            author: localStorage.getItem("display_name"),
            name: createUsersFormData.username,
            event_type: "Create New User",
            user_role: createUsersFormData.selectedRole,
            email: localStorage.getItem("userEmail"),
            author_ids: localStorage.getItem("current_user_Id"),
          };

          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
              notification_api_data,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });

          // recomandation data

          setCreateUsersFormData({
            username: "",
            email: "",
            password: "",
            selectedRole: "",
          });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
          console.error("Error creating user:", error);
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let tagIds = selectedTagOption.map((o) => o.id);
    let currentData = { ...formData };
    currentData["tags"] = tagIds;
    setFormData(currentData);
    // Send a POST request to create a new user
    console.log(currentData);
    axios
      .post(
        `${API_BASE_URL}/wp-json/custom/v1/update-user/${editId}`,
        currentData,
        config2
      )
      .then((response) => {
        toast.success("User Updated Successfully");
        setShow(false);
        setNotificationCount(notificationCount + 1);
        //store notification count start

        let notification_count = {
          // "user_id": "",
          count_value: "",
          reflect_count: "all_admin",
        };
        if (notification_count.count_value == "") {
          // post notification on usermeta start
          axios
            .post(
              `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
              notification_count,
              config2
            )
            .then((res) => {
              console.log(res.data);
            })
            .catch((err) => {
              console.log(err);
            });
        }

        // store notification count end

        //recomandation data
        let notification_api_data = {
          author: localStorage.getItem("display_name"),
          name: formData.username,
          event_type: "User Updated",
          email: localStorage.getItem("userEmail"),
          user_role: formData.selectedRole,
          author_ids: localStorage.getItem("current_user_Id"),
        };

        axios
          .post(
            `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
            notification_api_data,
            config2
          )
          .then((res) => {
            console.log(res.data);
          })
          .catch((err) => {
            console.log(err);
          });

        // recomandation data

        setReload(reload ? false : true);
      })
      .catch((error) => {
        console.error("Error creating user:", error);
      });
    // }
  };
  const navigate = useNavigate();
  const backBtn = () => {
    navigate("/searchLandingPage");
  };
  const uploadUsers = () => {
    navigate("/create-new-user-form");
  };
  useEffect(() => {
    console.log(tagsList);
    if (tagsList.length === 0) {
      axios
        .get(`${API_BASE_URL}/wp-json/wp/v2/tags`, {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("104REs=", res.data);
          setTagsList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [loadTagJson]);
  //
  useEffect(() => {
    if (!bearerToken) {
      navigate("/");
    } else {
      let sessionId = sessionStorage.getItem("sessionId");
      if (!sessionId) {
        let sessionId = Math.floor(Math.random() * 100000);
        sessionStorage.setItem("sessionId", sessionId);
        navigate("/all-articles");
      } else {
        // setLoading(true);
        axios
          .get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            console.log("line679dfdgdfg=", response.data);
            setUsers(response.data);

            const filterData = response.data.filter((res) => {
              if (
                res.user_roles != "administrator"
                // &&
                // res.user_roles != "editor"
              ) {
                return data;
              }
            });
            setTenantUsers(filterData);
            setTotalNoOfUsers(response.data.length);
            setLoading(false);
            setDeleteUsers(false);
            // setApiRespose(response.data.slice(0, 8))
          })
          .catch((error) => {
            console.error("Error fetching users:", error);
          });

        // create random password

        const min = 100000; // Minimum six-digit number
        const max = 999999; // Maximum six-digit number

        const randomPassword =
          Math.floor(Math.random() * (max - min + 1)) + min;
        setPassword(randomPassword.toString());

        console.log("randomPass=", randomPassword);

        // get all article

        axios
          .get(`${API_BASE_URL}/wp-json/wp/v2/posts?per_page=100`, {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((response) => {
            // setButtonVisible(true)
            console.log("470=", response.data);
            setAllArticle(response.data);
          })
          .catch((err) => {
            console.log(err);
          });
      }

      //
    }

    // create random password

    // document.querySelectorAll('[data-test="page-link"]').forEach((e)=>{
    //   console.log('pages :', e.innerText)
    //   if(e.innerText == page){
    //     e.innerHTML += `<span class="sr-only">(current)</span>`
    //   }
    // } )
  }, [reload, deleteUsers, createUsersShow]);

  // navigate to my articale page
  const CustomToastWithLink = () => (
    <div>
      To delete this user,
      <Link className="px-1" to="/table-posts">
        Click here
      </Link>
      to transfer articles associated with the user.
    </div>
  );

  // navigate to my articale page

  //delete users

  console.log("463", allArticle);
  const handleDelete = async (id) => {
    // setUserDeleteReload({ userDeletReload?userDeletReload=false: userDeletReload= true })
    // if (userDeletReload) {
    //   setUserDeleteReload(false)
    // } else {
    //   setUserDeleteReload(true)
    // }
    try {
      const confirmed = window.confirm(
        "Are you sure you want to delete this user?"
      );
      if (!confirmed) {
        // console.log(allArticle)
        return;
      } else {
        let Articles = await axios.get(
          `${API_BASE_URL}/wp-json/wp/v2/posts?per_page=100`,
          {
            headers: {
              Authorization: `Bearer ${bearerToken}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("446=", Articles.data);
        for (let i = 0; i < Articles.data.length; i++) {
          console.log("470", Articles.data[i]);
          if (Articles.data[i].author == id) {
            toast.error(CustomToastWithLink);
            return;
          }
        }

        const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/delete-user/${id}`;
        const config = {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
        };

        axios
          .delete(apiEndpoint, config)
          .then((response) => {
            toast.success("User Deleted Successfully");
            setDeleteUsers(true);
            setNotificationCount(notificationCount + 1);
            //
            let notification_count = {
              // "user_id": "",
              count_value: "",
              // reflect_count
              reflect_count: "all_admin",
            };
            if (notification_count.count_value == "") {
              // post notification on usermeta start
              axios
                .post(
                  `${API_BASE_URL}/wp-json/custom/v1/store-count/`,
                  notification_count,
                  config2
                )
                .then((res) => {
                  console.log(res.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            }

            //
            //recomandation data
            let notification_api_data = {
              author: localStorage.getItem("display_name"),
              name: response.data.deleted_user.user_name,
              event_type: "User Deleted",
              email: localStorage.getItem("userEmail"),
              user_role: response.data.deleted_user.user_role,
              author_ids: localStorage.getItem("current_user_Id"),
            };

            axios
              .post(
                `${API_BASE_URL}/wp-json/custom/v1/insert-notification-data`,
                notification_api_data,
                config2
              )
              .then((res) => {
                console.log(res.data);
              })
              .catch((err) => {
                console.log(err);
              });

            // recomandation data
          })
          .catch((error) => {
            console.error("Error deleting post:", error);
          });
      }
    } catch (error) {
      console.error("Error deleting Enter Code data:", error);
    }
  };
  // delete users
  const filterUsers = (query) => {
    return users.filter((user) => {
      const { user_login, user_email } = user;
      return (
        user_login.toLowerCase().includes(query) ||
        user_email.toLowerCase().includes(query)
      );
    });
  };
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredData = filterUsers(query);
    setFilteredUsers(filteredData);
    // currentPosts = filteredData.slice(indexOfFirstPost, indexOfLastPost)
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  let currentPosts;
  let pagenationLength;
  if (filteredUsers.length > 0) {
    pagenationLength = filteredUsers.length;
    currentPosts = filteredUsers.slice(indexOfFirstPost, indexOfLastPost);
  } else {
    currentPosts = users.slice(indexOfFirstPost, indexOfLastPost);
    pagenationLength = users.length;
  }

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };

  // sample csv code

  const downloadCsv = async () => {
    // Path to the local CSV file within the public folder
    const csvFilePath = "/bulk_user_upload_sample.csv";

    try {
      // Read the CSV file
      const response = await fetch(process.env.PUBLIC_URL + csvFilePath);
      const csvData = await response.text();

      // Convert CSV data to array
      const dataArray = Papa.parse(csvData).data;

      // Convert array back to CSV string
      const csv = Papa.unparse(dataArray);

      // Create a Blob and initiate download
      const blob = new Blob([csv], { type: "text/csv" });
      const link = document.createElement("a");

      link.href = URL.createObjectURL(blob);
      link.download = "bulk_user_upload_sample.csv";

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
    } catch (error) {
      console.error("Error reading CSV file:", error);
    }
  };

  let current_user_Id = localStorage.getItem("current_user_Id");
  console.log("current_user_Id=", current_user_Id);

  console.log("line804", users);
  const data = useMemo(
    () => ({
      columns: [
        {
          label: "Name",
          field: "name",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Date Created",
          field: "user_registered",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Role",
          field: "role",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Tags",
          field: "user_tags",
          // sort: 'asc',
          width: 350,
        },
        {
          label: "Status",
          field: "user_status",
          width: 100,
        },
        {
          label: "Last login",
          field: "last_login",
          width: 100,
        },
        {
          label: "Action",
          field: "delete_admin",
          sort: "disabled",
          width: 50,
        },
      ],

      rows: users?.map((e) => {
        function toCapitalize(text) {
          return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        let current = e;
        console.log("991=", current);
        let userRole;
        if (current.user_roles == "subscriber") {
          userRole = "Reader";
        } else if (current.user_roles == "editor") {
          userRole = "Tenant Admin";
        } else {
          userRole = current.user_roles;
        }

        if (current["user_tags"]?.length > 0) {
          let selectedtags = tagsList.filter((item) =>
            current["user_tags"].includes(item.id)
          );

          current["user_tags"] = selectedtags.map((o) => o.name).join(", ");
        } else {
          current["user_tags"] = "";
        }
        if (e.ID != parseInt(current_user_Id)) {
          return Object.assign(
            e,

            {
              delete_admin: (
                <div className="d-flex justify-content-center ">
                  {/* <FaUserEdit
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Edit"
                    role="button"
                    onClick={() => handleShow(current.ID)}
                    size={25}
                    color="#0d6efd"
                  />{" "} */}
                  <img
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Edit"
                    role="button"
                    onClick={() => handleShow(current.ID)}
                    src={FaUserEdit}
                    alt=""
                  />
                  {/* <MdDeleteForever
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Delete"
                    onClick={() => handleDelete(current.ID)}
                    size={25}
                    color="#0d6efd"
                    role="button"
                  />{" "} */}
                  <img
                    className="mx-2"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Delete"
                    role="button"
                    onClick={() => handleDelete(current.ID)}
                    src={MdDeleteForever}
                    alt=""
                  />
                </div>
              ),

              name: toCapitalize(current.user_login),
              role: userRole,
              last_login: e.last_logged_in,
            }
          );
        } else {
          return Object.assign(e, {
            name: toCapitalize(current.user_login),
            role: userRole,
            last_login: e.last_logged_in,
          });
        }
      }),
    }),
    [users]
  );

  const tenantData = useMemo(
    () => ({
      columns: [
        {
          label: "Name",
          field: "name",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Date Created",
          field: "user_registered",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Role",
          field: "role",
          // sort: 'asc',
          width: 150,
        },
        {
          label: "Tags",
          field: "user_tags",
          // sort: 'asc',
          width: 350,
        },
        {
          label: "Status",
          field: "user_status",
          width: 100,
        },
        {
          label: "Last login",
          field: "last_login",
          width: 100,
        },
        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 50,
        },
      ],

      rows: tenantUsers?.map((e) => {
        function toCapitalize(text) {
          return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
        }
        let current = e;
        console.log("currendata=", current);
        let userRole;
        if (current.user_roles == "subscriber") {
          userRole = "Reader";
        } else if (current.user_roles == "editor") {
          userRole = "Tenant Admin";
        } else {
          userRole = current.user_roles;
        }

        if (current["user_tags"]?.length > 0) {
          let selectedtags = tagsList.filter((item) =>
            current["user_tags"].includes(item.id)
          );

          current["user_tags"] = selectedtags.map((o) => o.name).join(", ");
        } else {
          current["user_tags"] = "";
        }
        if (e.ID != parseInt(current_user_Id)) {
          return Object.assign(
            e,

            {
              delete: (
                <div className="d-flex justify-content-center ">

                  <img
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Edit"
                    role="button"
                    onClick={() => handleShow(current.ID)}
                    src={FaUserEdit}
                    alt=""
                  />

                  {/* <img
                    className="mx-2"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Delete"
                    role="button"
                    onClick={() => handleDelete(current.ID)}
                    src={MdDeleteForever}
                    alt=""
                  /> */}
                </div>
              ),

              name: toCapitalize(current.user_login),
              role: userRole,
              last_login: e.last_logged_in,
            }
          );
        } else {
          return Object.assign(e, {
            name: toCapitalize(current.user_login),
            role: userRole,
            last_login: e.last_logged_in,
          });
        }
      }),
    }),
    [tenantUsers]
  );
  const downloadCSV = () => {
    const headers = "Name,Email,Role\n";
    // console.log("users=", users[4].role);
    // return;
    // .join(", ")
    // Filter users based on the current user's role
    const filteredUsers = localStorage.getItem("roles") === "editor"
      ? users.filter(user => user.role.toLowerCase() !== "administrator")
      : users;

    const userRows = filteredUsers
      .map(user => `${user.name},${user.user_email},${user.role.toLowerCase()}\n`)
      .join("");
    const csvContent = headers + userRows;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "users.csv");
  };
  return (
    <div>
      <div>
        <div className="row g-0">
          <div
            className={
              collaps ? "column right-column  col" : "column right-column  col "
            }
          >
            <div className="w-100">
              <NewTopNavBar />
            </div>
            {/* <!-- Content for the right column goes here --> */}

            {/*  */}
            <Modal show={createUsersShow} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Create User</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row g-0 w-100 ">
                  <form>
                    <div className="form-group">
                      <label for="exampleInputEmail1">User Name:</label>
                      <input
                        className="form-control"
                        type="text"
                        name="username"
                        value={createUsersFormData.username}
                        placeholder="Username"
                        onChange={handleChangeCreateUsers}
                      />
                      {errors.username && (
                        <p className="error">{errors.username}</p>
                      )}
                    </div>

                    <div className="form-group">
                      <label for="exampleInputEmail1">Email:</label>
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        value={createUsersFormData.email}
                        placeholder="Email"
                        onChange={handleChangeCreateUsers}
                      />
                      {errors.email && <p className="error">{errors.email}</p>}
                    </div>

                    <div className="form-group">
                      <label>Role:</label>
                      <select
                        className="w-100"
                        id="categorySelect"
                        name="selectedRole"
                        value={createUsersFormData.selectedRole}
                        onChange={handleChangeCreateUsers}
                      >
                        <option value="">Select Role</option>
                        {roles.map((role) => (
                          <option key={role.name} value={role.name}>
                            {role.value}
                          </option>
                        ))}
                      </select>
                      {errors.selectedRole && (
                        <p className="error">{errors.selectedRole}</p>
                      )}
                    </div>
                    {createUsersFormData.selectedRole == "subscriber" ? (
                      <div className="form-group">
                        <label>Tags:</label>
                        {/* ///////////////////////////////////Tag Dropdown Start//////////////////////////////////////// */}

                        <div className="p-1 pe-2">
                          <Select
                            key={tagDropDownKey}
                            closeMenuOnSelect={false}
                            className="tagSelectorMulti"
                            isMulti={true}
                            placeholder="Select Tags"
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.name}
                            options={tagsList}
                            onChange={setSelectedTagOption}
                            defaultValue={defaultTagList}
                          />
                        </div>
                        {/* ///////////////////////////////////Tag Dropdown End//////////////////////////////////////// */}
                      </div>
                    ) : (
                      ""
                    )}
                  </form>
                </div>
              </Modal.Body>
              <Modal.Footer>
                {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
                {/* <Button variant="primary" onClick={handleSubmitCreateUsers}>
                  Create User
                </Button> */}
                <img
                  className="commonLogo"
                  // width={40}
                  onClick={handleSubmitCreateUsers}
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Create user"
                  role="button"
                  src={UpdateImage}
                  alt=""
                />
              </Modal.Footer>
            </Modal>

            <div
              className="w-100"
              style={{
                minHeight: "85vh",
                padding: "15px 20px 10px 40px",
                width: "95%",
              }}
            >
              {!loading ? (
                <div
                  style={{
                    // background: '#ececec',
                    boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                    // margin: '20px 30px'
                  }}
                  className="row w-100"
                >
                  <div className="col-2"></div>
                  <div className="col-12 px-5 pt-2">
                    {/*  */}

                    <Modal show={show} onHide={handleClose} centered>
                      <Modal.Header closeButton>
                        <Modal.Title>Edit User</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        {" "}
                        <div className="row g-0 w-100 ">
                          <div className="col-3"></div>
                          <div className="col-12">
                            <form>
                              <div className="form-group">
                                <label for="exampleInputEmail1">
                                  User Name:
                                </label>
                                <input
                                  className="form-control"
                                  type="text"
                                  name="username"
                                  disabled
                                  value={formData.username}
                                  placeholder="Username"
                                  onChange={handleChange}
                                />
                                {/* {errors.username && <p className="error">{errors.username}</p>} */}
                              </div>

                              <div className="form-group">
                                <label for="exampleInputEmail1">Email:</label>
                                <input
                                  className="form-control"
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  placeholder="Email"
                                  disabled
                                  onChange={handleChange}
                                />
                                {/* {errors.email && <p className="error">{errors.email}</p>} */}
                              </div>

                              <div className="form-group">
                                <label>Role:</label>
                                <select
                                  className="w-100"
                                  id="categorySelect"
                                  name="selectedRole"
                                  value={formData.selectedRole}
                                  onChange={handleRoleChange}
                                >
                                  {roles.map((role) => (
                                    <option key={role.name} value={role.name}>
                                      {role.value}
                                      {/* {role.charAt(0).toUpperCase() + role.slice(1)} */}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              {/*  */}
                              <div className="form-group">
                                <label>Status:</label>
                                <select
                                  name="status"
                                  className="w-100"
                                  id="categorySelect"
                                  value={formData.status}
                                  onChange={handleRoleChange}
                                >
                                  <option value="active">Active</option>
                                  <option value="inactive">Inactive</option>
                                </select>
                              </div>
                              {/*  */}
                              {/* <div className='mt-2 text-center'>
                          <button onClick={handleSubmit} type="button" className="btn btn-primary">Create User</button>
                        </div> */}
                              {formData.selectedRole == "subscriber" ? (
                                <div className="form-group">
                                  <label>Tags:</label>
                                  {/* ///////////////////////////////////Tag Dropdown Start//////////////////////////////////////// */}

                                  <div className="p-1 pe-2">
                                    <Select
                                      key={tagDropDownKey}
                                      closeMenuOnSelect={false}
                                      className="tagSelectorMulti"
                                      isMulti={true}
                                      placeholder="Select Tags"
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.name}
                                      options={tagsList}
                                      onChange={setSelectedTagOption}
                                      defaultValue={defaultTagList}
                                    />
                                  </div>
                                  {/* ///////////////////////////////////Tag Dropdown End//////////////////////////////////////// */}
                                </div>
                              ) : (
                                ""
                              )}
                            </form>
                          </div>
                          <div className="col-3"></div>
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        {/* <Button variant="secondary" onClick={handleClose}>
                          Close
                        </Button> */}
                        {/* <Button variant="primary" onClick={handleSubmit}>
                          Save Changes
                        </Button> */}
                        <img
                          className="commonLogo"
                          // width={40}
                          onClick={handleSubmit}
                          data-toggle="tooltip"
                          data-placement="bottom"
                          title="Update"
                          role="button"
                          src={UpdateImage}
                          alt=""
                        />
                      </Modal.Footer>
                    </Modal>
                    {/*  */}

                    {/* <div style={{ minHeight: "50vh" }}> */}
                    {/*  */}
                    {/* <button onClick={downloadCSV}>Download Users as CSV</button> */}
                    {/*  */}
                    <h3 className="fw-bold  ">Manage Users</h3>
                    <div className="">
                      <b>Choose files to upload mutiple users</b>
                    </div>
                    <div className="userUpload-search-mainDiv ">
                      <div style={{ width: "40%" }}>
                        {/* <Form> */}
                        {/* <Form.Group> */}
                        <div className="upload-users-section input-group align-items-center">
                          <input
                            className="form-control "
                            type="file"
                            id="csvFile"
                            label="Choose a CSV file to upload"
                            onChange={handleFileChange}
                          />
                          {/* </Form.Group> */}
                          <div className="">
                            {/* <button type='submit' className='input-group btn  btn-primary m-0'
                              // style={{ backgroundColor: 'rgb(18, 178, 142)', color: "white" }}

                              onClick={handleUpload}
                            > */}
                            <img
                              className="ms-3 commonLogo"
                              onClick={handleUpload}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Bulk user upload"
                              role="button"
                              // width={30}
                              src={UploadImage}
                              alt=""
                            />
                            {/* </button> */}
                          </div>
                        </div>
                        {/* </Form> */}
                      </div>
                      <div className="d-flex align-items-center ps-2">
                        <div>
                          {/* <button className='btn  btn-primary m-0' onClick={downloadCsv}>Download Sample CSV</button> */}
                          <img
                            className="commonLogo"
                            onClick={downloadCsv}
                            // width={30}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Download sample file"
                            role="button"
                            src={DownloadSampleCsv}
                            alt="Download Sample Csv"
                          />
                        </div>
                        <div className="px-2" style={{}}>
                          {/* <button className='btn  btn-primary ' onClick={createusersHandleChange}>+Create User</button> */}
                          <img
                            className="commonLogo"
                            // width={40}
                            onClick={createusersHandleChange}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Create User"
                            role="button"
                            src={CreateUser}
                            alt=""
                          />
                        </div>

                        <div className="" style={{}}>
                          {/* <button className='btn  btn-primary ' onClick={createusersHandleChange}>+Create User</button> */}
                          <img
                            // width={40}
                            className="commonLogo"
                            onClick={downloadCSV}
                            data-toggle="tooltip"
                            data-placement="bottom"
                            title="Download Users"
                            role="button"
                            src={DownloadCsv}
                            alt=""
                          />
                        </div>
                        {/*  */}
                        {/*  */}
                      </div>
                    </div>
                    {localStorage.getItem("roles") == "administrator" ? (
                      <MDBDataTable
                        fixed
                        sortable
                        className="data-table text-capitalize"
                        onPageChange={(e) => setPage(e.activePage)}
                        bordered
                        entries={5}
                        entriesOptions={[2, 5, 10, 15, 20]}
                        data={data}
                        noBottomColumns
                        disableRetreatAfterSorting={true}
                      />
                    ) : (
                      <MDBDataTable
                        fixed
                        sortable
                        className="data-table text-capitalize"
                        onPageChange={(e) => setPage(e.activePage)}
                        bordered
                        entries={5}
                        entriesOptions={[2, 5, 10, 15, 20]}
                        data={tenantData}
                        noBottomColumns
                        disableRetreatAfterSorting={true}
                      />
                    )}
                  </div>
                </div>
              ) : (
                // </div>
                <div className="w-100 text-center mt-5">
                  <Spinner />
                </div>
              )}
            </div>
          </div>
          {/* {alert(loading)} */}
        </div>
      </div>
    </div>
  );
}

export default CreateNewUserForm;
